import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Tag'}</title>
      <g>
        <path d="M152 108.5c0-11.8-4.2-21.9-12.5-30.3-8.4-8.4-18.5-12.5-30.3-12.5s-21.9 4.2-30.3 12.5-12.5 18.5-12.5 30.3 4.2 21.9 12.5 30.3 18.5 12.5 30.3 12.5 21.9-4.2 30.3-12.5 12.5-18.5 12.5-30.3zm356.9 192.6c0 11.8-4.1 21.9-12.4 30.1l-164.2 164.6c-8.7 8.2-18.8 12.4-30.5 12.4-11.8 0-21.9-4.1-30.1-12.4l-239.1-239.5c-8.5-8.2-15.7-19.5-21.6-33.8s-8.8-27.3-8.8-39.1v-139.2c0-11.6 4.2-21.6 12.7-30.1s18.5-12.7 30.1-12.7h139.2c11.8 0 24.8 3 39.1 8.8 14.3 5.9 25.6 13.1 34.1 21.6l239.1 238.8c8.2 8.8 12.4 18.9 12.4 30.5z" />
      </g>
    </Icon>
  )
}
